<div class="reference-item">
    <label class="reference-link">
        <a [href]="info.url" target="_blank">{{info.title}}</a>
    </label>
    <div *ngIf="isAskMyDocsReference" class="file-info">
        <p *ngIf="info.extension" class="file-extension">[{{info.extension}}]</p>
        <p *ngIf="info.pageReference" class="file-page-reference">{{info.pageReference}}</p>
    </div>
</div>
